module.exports = __webpack_public_path__ + "static/media/fj.f395a43a.svg";